"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.SecurityRoleAPI = {
    getSecurityRoles: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/securityRoles")
            .then(function (response) {
            var securityRoles = response.data.securityRoles;
            return securityRoles;
        });
    },
    getMyPermissions: function (userId) {
        return index_1.axios.get("/api/v1/user/" + userId + "/userPermissions").then(function (response) {
            var userPermissions = response.data.userPermissions;
            return userPermissions;
        });
    },
    addSecurityRole: function (companyId, createObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/securityRoles", createObject)
            .then(function (response) {
            var securityRole = response.data;
            return securityRole;
        });
    },
    updateSecurityRole: function (companyId, securityRoleId, updateObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/securityRoles/" + securityRoleId, updateObject)
            .then(function (response) {
            var securityRole = response.data;
            return securityRole;
        });
    },
};
//# sourceMappingURL=SecurityRoleAPI.js.map